import React from "react"
export const ComplianceDetailContext = React.createContext(null);

export const useComplianceDetailContext = () => {

    const context = React.useContext(ComplianceDetailContext);

    if (!context) throw new Error("Compliance Detail Context not provided!");

    return context;
}